import Hero from "../../components/landing/Hero";
import InsuranceChoices from "../../components/landing/InsuranceChoices";
import Features from "../../components/landing/Features";
import NewsletterForm from "../../components/landing/NewsletterForm";
import Footer from "../../components/landing/Footer";
import CTA from "../../components/landing/CTA";
import GuestNavbar from "../../components/navigations/GuestNavbar";
import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      {/* Guest Navbar */}
      <GuestNavbar />
      
      {/* Hero Section */}
      <Hero />

      {/* Insurance Choices Section */}
      <InsuranceChoices />

      {/* Features Section*/}
      <Features />

      {/* Newsletter Section */}
      <NewsletterForm />

      {/* CTA Section */}
      <CTA />

      {/* Footer */}
      <Footer />
    </div>
  );
}
